import { Point } from '../../Commons/Geometry';
import { type TerceraChartWindowBase } from '../Windows/TerceraChartWindowBase';

export class TerceraChartMouseEventArgs {
    public window: TerceraChartWindowBase;
    public NeedRedraw = false;
    public _baseEvent: any;
    public Button: any;
    public X: number;
    public Y: number;
    public Delta: number;
    public Location: Point;
    public ClientLocation: Point;

    constructor (ww: TerceraChartWindowBase, ev) {
        this.window = ww;
        this._baseEvent = ev;
        this.Button = ev.button;
        this.X = ev.offsetX;
        this.Y = ev.offsetY;
        this.Delta = -1 * parseInt(ev.deltaY);
        this.Location = new Point(this.X, this.Y);
        this.ClientLocation = new Point(ev.clientX, ev.clientY);
    }
}
